import HttpService from "../util/HttpService";
import {ContactDetailDto} from "../dto/ContactDetailDto";
import {ComplaintRequestDto} from "../dto/ComplaintRequestDto";
import {OtherRequestDto} from "../dto/OtherRequestDto";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/cwm/api/v2";
class CustomerChangeRequestService {
    getCustomerAddressDetailsList = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-customer-address-details-list/") + ParamEncrypt.encryptData(cin));
    }

    submitAddressChangeRequest = (addressDto: any, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/submit-address-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(addressDto));
    }

    getCustomerContactDetailsList = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-customer-contact-detail/") + ParamEncrypt.encryptData(cin));
    }

    submitCustomerContactDetailChangeRequest = (contactDetailDto: ContactDetailDto, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/submit-customer-contact-detail-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(contactDetailDto));
    }
    submitComplaintRequest = (complaintRequestDto: ComplaintRequestDto, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/submit-complaint-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(complaintRequestDto));
    }
    submitOtherRequest = (otherRequestDto: OtherRequestDto, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/submit-other-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(otherRequestDto));
    }

    getCustomerBankDetailList = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-customer-bank-detail-list/") + ParamEncrypt.encryptData(cin));
    }
    submitCustomerBankDetailChangeRequest = (bankDetailWrapperDto: any, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/submit-customer-bank-detail-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(bankDetailWrapperDto));
    }

    getComplaintChangeRequestHistory = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-complaint-change-request-history/") + ParamEncrypt.encryptData(cin));
    }
    getOtherRequestHistory = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-other-request-history/") + ParamEncrypt.encryptData(cin));
    }

    getContactDetailChangeRequestHistory = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-contact-detail-change-request-history/") + ParamEncrypt.encryptData(cin));
    }
    getAddressDetailChangeRequestHistory = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-address-change-request-history/") + ParamEncrypt.encryptData(cin));
    }
    getBankDetailChangeRequestHistory = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-bank-detail-change-history/") + ParamEncrypt.encryptData(cin));
    }
    getCustomerSignatureDetail = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-signature-detail/") + ParamEncrypt.encryptData(cin));
    }
    submitCustomerSignatureChangeRequest = (signatureDto: any, cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/submit-signature-change-request/") + ParamEncrypt.encryptData(cin), ParamEncrypt.encryptObject(signatureDto));
    }
    cancelCustomerAddressChangeRequest = (groupId: number) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/cancel-address-change-request/") + ParamEncrypt.encryptData(String(groupId)), null);
    }

    cancelCustomerContactChangeRequest = (cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/cancel-contact-detail-change-request/") + ParamEncrypt.encryptData(cin), null);
    }

    cancelCustomerBankChangeRequest = (groupId: number) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/cancel-bank-detail-change-request/") + ParamEncrypt.encryptData(String(groupId)), null);
    }

    cancelCustomerSignatureChangeRequest = (cin: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-change-request-service/cancel-signature-change-request/") + ParamEncrypt.encryptData(cin), null);
    }
    getCustomerSignatureDetailHistory = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-change-request-service/get-signature-change-request-history/") + ParamEncrypt.encryptData(cin));
    }

    generateChangeRequestOtp = () => {
        return HttpService.post(CONTEXT_PATH.concat("/otp-service/change-request-otp"), null);
    }
}

const customerChangeRequestService = new CustomerChangeRequestService();
export default customerChangeRequestService;